import { Component, OnChanges, OnDestroy } from '@angular/core';
import { Input, Output, EventEmitter } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

import { Subscription } from 'rxjs';

import { ViewRenderer } from '@unpispas/upp-wdgt';

import { languageService, languageSupport } from '@unpispas/upp-base';
import { dataService, UserView } from '@unpispas/upp-data';
import { viewService } from '@unpispas/upp-base';

import { PlaceView } from '@unpispas/upp-data';

@Component({
    selector: 'upp-place-thumb',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './upp-thumb.html',
    styleUrls: [
      './upp-thumb.scss'
    ],
    providers: [{
        provide: ViewRenderer,
        useFactory: (change: ChangeDetectorRef) => new ViewRenderer(change),
        deps: [ChangeDetectorRef]
    }]       
})
export class UppPlaceThumbComponent extends languageSupport implements OnChanges, OnDestroy {
    @Input() place: PlaceView | null = null;

    @Output() Select = new EventEmitter <PlaceView | null> ();

    private _place_subscription: Subscription | null = null;

    constructor(private lang: languageService, private change: ViewRenderer, private data: dataService, public view: viewService){
        super(lang, change.cdref);
    }

    ngOnChanges(){
        if (this._place_subscription){
            this._place_subscription.unsubscribe();
            this._place_subscription = null;
        }

        if (this.place){
            this._place_subscription = this.place.OnViewRefresh.subscribe(
            () => {
                this.change.markForCheck();
            });
        }
    }

    ngOnDestroy(): void {
        super.OnDestroy();

        if (this._place_subscription){
            this._place_subscription.unsubscribe();
            this._place_subscription = null;
        }
    }

    /********************************/
    /* DISPLAY OPTIONS              */
    /********************************/  
    
    private _user: UserView | null = null;

    private get user(): UserView {
        if (this._user === null){
            this._user = this.data.alives.get(this.data.user) as UserView;
        }
        return this._user;
    }

    IsOwner(){
        if (!this.place){
            return false;
        }

        return this.user == this.place.user;
    }

    /********************************/
    /* EVENT HANDLERS               */
    /********************************/

    OnSelect(){
        this.Select.emit(this.place);
    }
}